import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import logo from '../company.png';
import '../App.css';

//const url = process.env.REACT_APP_SERVER_URL;
const url = process.env.REACT_APP_SERVER_URL || "https://centralsoft.com.my"; // fallback
function Dashboard() {
  const [adminID, setAdminID] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");

  const [showRegister, setShowRegister] = useState(false);
  const [registerData, setRegisterData] = useState({
    stallID: "",
    stallName: "",
    password: "",
    confirmPassword: ""
  });
  const [registerMsg, setRegisterMsg] = useState("");

  // 
  // 🔹 Check localStorage on load
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedStallID = localStorage.getItem("stallID");
    if (storedUsername && storedStallID) {
      setUsername(storedUsername);
      setIsLoggedIn(true);
    }
  }, []);

 const adminUpdate = async () => {
  try {
    const response = await axios.put(`${url}/api/admin/updateAdmin`, registerData);

    setRegisterMsg(`✅ ${response.data.message}`);
  } catch (err) {
    console.error("❌ Admin update failed:", err);
    setRegisterMsg(`❌ ${err.response?.data?.message || "Server error"}`);
  }
};

  // 🔹 Login handler
 const handleLogin = async (e) => {
  e.preventDefault();
  
 // const url = process.env.REACT_APP_SERVER_URL; // make sure this is set in .env
console.log("URL: "+url);
  if (!url) {
    console.error("❌ Backend URL is not defined!");
    setMessage("⚠️ Backend URL not set. Check .env");
    return;
  }

  console.log("🌐 Backend URL:", url);
  console.log("📤 Sending login payload:", { adminID, password });
  console.log("Admin ID: "+adminID);
  try {
    const res = await axios.post(`${url}/api/admin/login`, 
      { adminID, password },
      {
        headers: { "Content-Type": "application/json" },
        timeout: 10000, // 10s timeout to catch unresponsive server
      }
    );

    console.log("✅ Login response:", res);
    console.log("📝 Response data:", res.data);
    console.log("Stall Name: "+res.data.admins.username);
    if (res.data.success) {
      setMessage("✅ Login success!");
      localStorage.setItem("stallID", res.data.admins.stallID);
      localStorage.setItem("username", res.data.admins.username);
      setUsername(res.data.admins.username);
      setIsLoggedIn(true);
    } else {
      setMessage("❌ " + res.data.message);
    }

  } catch (err) {
    console.error("⚠️ Login error:", err);

    if (err.response) {
      // Server responded with a status outside 2xx
      console.error("Server responded:", err.response);
      setMessage(`⚠️ Server responded: ${err.response.status} ${err.response.statusText}`);
    } else if (err.request) {
      // Request was made but no response received
      console.error("No response received. Request info:", err.request);
      setMessage("⚠️ No response from server. Check backend or network.");
    } else {
      // Something went wrong setting up the request
      console.error("Request setup error:", err.message);
      setMessage("⚠️ " + err.message);
    }
  }
};


  // 🔹 Logout handler
  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setUsername("");
  };

  // 🔹 Register handler
  const handleRegister = async (e) => {
  e.preventDefault();

  if (!url) {
    console.error("❌ Backend URL is not defined!");
    setRegisterMsg("⚠️ Backend URL not set. Check .env");
    return;
  }
  console.log('Register data :'+registerData.stallID);
  try {
    const res = await axios.post(`${url}/api/admin/register`, registerData);
    console.log("Register response:", res.data);

    if (res.data.success) {
      setRegisterMsg("✅ Registration successful!");
      setShowRegister(false);
      setRegisterData({ stallID: "", stallName: "", password: "", confirmPassword: "" });
    } else {
      setRegisterMsg("❌ " + res.data.message);
    }
  } catch (err) {
    console.error("Register error:", err);
    if (err.response) {
      setRegisterMsg(`⚠️ Server responded: ${err.response.status} ${err.response.statusText}`);
    } else if (err.request) {
      setRegisterMsg("⚠️ No response from server");
    } else {
      setRegisterMsg("⚠️ " + err.message);
    }
  }
};
  return (
    <div style={{ padding: "30px", textAlign: "center", fontFamily: "Arial" }}>
      <img src={logo} width='70' height='70' className="App-logo" alt="logo" />
      <h1>🍔 Codesquad Food Ordering System 1.0</h1>
      <p style={{ marginBottom: "30px" }}>Welcome to the Dashboard</p>

      {!isLoggedIn ? (
        <div className="d-flex justify-content-center align-items-start vh-100 bg-light">
          <div className="card shadow p-4" style={{ width: "400px" }}>
            {/* 🔹 Login Form */}
            <h2 className="text-center mb-4 text-danger">🔐 Admin Login</h2>
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Stall ID</label>
                <input
                  type="text"
                  className="form-control"
                  value={adminID}
                  onChange={(e) => setAdminID(e.target.value.toLowerCase())}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pasted = e.clipboardData.getData("text").toLowerCase();
                    setAdminID(pasted);
                  }}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100">Login</button>
            </form>
            {message && <p className="text-center mt-3 text-danger">{message}</p>}

            <hr />

            {/* 🔹 Toggle Register Form */}
            <button
              className="btn btn-success w-100 mb-3"
              onClick={() => {
                setShowRegister(!showRegister);
                setRegisterMsg("");
              }}
            >
              User Register / Edit
            </button>

            {/* 🔹 Register Form */}
            {showRegister && (
              <form onSubmit={handleRegister}>
                <div className="mb-3">
                  <label className="form-label">Stall ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={registerData.stallID}
                    onChange={(e) =>
                      setRegisterData({ ...registerData, stallID: e.target.value.toLowerCase() })
                    }
                    onPaste={(e) => {
                      e.preventDefault();
                      const pasted = e.clipboardData.getData("text").toLowerCase();
                      setRegisterData({ ...registerData, stallID: pasted });
                    }}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Stall Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={registerData.stallName}
                    onChange={(e) => setRegisterData({ ...registerData, stallName: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={registerData.password}
                    onChange={(e) => setRegisterData({ ...registerData, password: e.target.value })}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={registerData.confirmPassword}
                    onChange={(e) => setRegisterData({ ...registerData, confirmPassword: e.target.value })}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-warning w-100">Register</button>
                {registerMsg && (
                  <p
                    className="text-center mt-3"
                    style={{ color: registerMsg.includes("✅") ? "green" : "red" }}
                  >
                    {registerMsg}
                  </p>
                )}
                <button
  type="button"
  className="btn btn-success w-100"
  onClick={adminUpdate}
>
  Update User
</button>

{registerMsg && (
  <p
    className="text-center mt-3"
    style={{ color: registerMsg.includes("✅") ? "green" : "red" }}
  >
    {registerMsg}
  </p>
)}
              </form>
            )}
          </div>
        </div>
      ) : (
        // 🔹 Dashboard Menu when logged in


        <div>
          <p>Welcome, <b>{username}</b> 👋</p>
          <div className="dropdown" style={{ marginTop: "20px", display: "inline-block" }}>
            <button className="btn btn-success dropdown-toggle" type="button" id="dashboardMenu" data-bs-toggle="dropdown" aria-expanded="false">
              Dashboard Menu
            </button>
            <ul className="dropdown-menu" aria-labelledby="dashboardMenu">
              <li><Link className="dropdown-item" to="/category">Category Management</Link></li>
              <li><Link className="dropdown-item" to="/foods">Foods Profile</Link></li>
             <li><Link className="dropdown-item" to="/addons-management">Addons Management</Link></li>
              <li><Link className="dropdown-item" to="/PrintableQRCodeCanvas">QRCode</Link></li>
              <li><Link className="dropdown-item" to="/ordering">Foods Ordering</Link></li>
              <li><Link className="dropdown-item" to="/KitchenDisplay">Kitchen Display</Link></li>
              <li><Link className="dropdown-item" to="/OrderStatusPage">Ordering Status</Link></li>
              <li><Link className="dropdown-item" to="/MobileOrderPage">Mobile Food Ordering</Link></li>
                </ul>
          </div>
          <div style={{ marginTop: "20px" }}>
            <button onClick={handleLogout} className="btn btn-danger">Logout</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
